import React from 'react';
import { Grid } from '@mui/material';
import { dropStatusDocumento } from 'utils/drops';
import Input from 'components/Input';
import InputMask from 'components/InputMask';
import VirtualDrop from 'components/VirtualDrop';
import Dropdown from 'components/Dropdown';

const Filter = ({ grid, control, drops }) => {
  const checkDisplay = (name) => {
    const column = grid?.colunas?.find((c) => c?.field === name);
    if (column?.filterable) {
      return true;
    }
    return false;
  };

  return (
    <Grid container spacing={2}>
      {checkDisplay('id') && (
        <Grid item xs={12}>
          <Input name="id" control={control} label="ID" type="number" />
        </Grid>
      )}
      {checkDisplay('status') && (
        <Grid item xs={12}>
          <Dropdown
            name="status"
            control={control}
            label="Status"
            options={dropStatusDocumento}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('situacao') && (
        <Grid item xs={12}>
          <Dropdown
            name="situacao"
            control={control}
            label="Situação"
            options={drops?.StatusDocumento}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('natureza_operacao') && (
        <Grid item xs={12}>
          <Dropdown
            name="natureza_operacao"
            control={control}
            label="Natureza da Operação"
            options={drops?.NaturezaOperacao}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('dtemissao') && (
        <Grid item xs={6}>
          <InputMask
            name="dtemissao.i"
            control={control}
            label="Data de Emissão Inicial"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('dtemissao') && (
        <Grid item xs={6}>
          <InputMask
            name="dtemissao.f"
            control={control}
            label="Data de Emissão Final"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('dtentrada') && (
        <Grid item xs={6}>
          <InputMask
            name="dtentrada.i"
            control={control}
            label="Data de Entrada Inicial"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('dtentrada') && (
        <Grid item xs={6}>
          <InputMask
            name="dtentrada.f"
            control={control}
            label="Data de Entrada Final"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('documento') && (
        <Grid item xs={12}>
          <Input
            name="documento"
            control={control}
            label="Nº do Documento"
            type="number"
          />
        </Grid>
      )}
      {checkDisplay('entidade') && (
        <Grid item xs={12}>
          <VirtualDrop
            name="entidade"
            control={control}
            label="Entidade"
            options={drops?.Entidade}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('vldocto') && (
        <Grid item xs={12}>
          <InputMask name="vldocto" control={control} label="Valor" />
        </Grid>
      )}
      {checkDisplay('filial') && (
        <Grid item xs={12}>
          <Dropdown
            name="filial"
            control={control}
            label="Filial"
            options={drops?.Filial}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('whatsapp') && (
        <Grid item xs={12}>
          <Input name="whatsapp" control={control} label="Contato" />
        </Grid>
      )}
    </Grid>
  );
};

export default Filter;
